import React, { type SelectHTMLAttributes } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import InputRenderer from "src/shared/forms/formrenderers/InputRenderer";
import type IFormInputs from "src/shared/forms/inputs/IFormInputs";
import PleaseSelect from "src/shared/forms/inputs/PleaseSelect";
import { required as Required } from "src/shared/forms/validations/Required";
import type TermTemplate from "src/shared/term/objects/TermTemplate";

export interface ITermClassInputProps
  extends IFormInputs,
    SelectHTMLAttributes<HTMLSelectElement> {
  termTemplates: TermTemplate[];
}

export default (props: ITermClassInputProps) => {
  const {
    children,
    inputID,
    label = <FormattedMessage id="term.term_class" />,
    validationDisabled,
    termTemplates,
    ...rest
  } = props;
  return (
    <Field
      name={inputID}
      label={label}
      type="select"
      component={InputRenderer}
      validate={!validationDisabled ? [Required] : undefined}
      {...rest}
    >
      <PleaseSelect />

      {termTemplates.map((termTemplate) => (
        <option value={termTemplate.termClass} key={termTemplate.termClass}>
          {termTemplate.description}
        </option>
      ))}
    </Field>
  );
};
